"use client"

import { XIcon } from "lucide-react"
import ReactDatePicker from "react-datepicker"
import { isSameDay } from "date-fns"

import { Checkbox } from "./ui/checkbox"
import { Button } from "./ui/button"
import { cn } from "../../lib/utils"

export function CalendarSidebar({
  calendars,
  activeCalendars,
  onToggleCalendar,
  onClose,
  currentDate,
  onDateChange,
}) {
  return (
    <div className="flex h-full flex-col gap-6 overflow-y-auto p-5">
      <div className="flex items-start justify-between gap-2">
        <div>
          <h2 className="text-lg font-semibold">Calendars</h2>
          <p className="text-muted-foreground text-sm">
            Choose which calendars are visible in your view.
          </p>
        </div>
        {onClose && (
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={onClose}
            aria-label="Close sidebar"
          >
            <XIcon size={16} aria-hidden="true" />
          </Button>
        )}
      </div>

      <div className="rounded-xl border border-border/70 bg-card/50 p-2">
        <ReactDatePicker
          inline
          selected={currentDate}
          onChange={(date) => {
            if (date) onDateChange?.(date)
          }}
          calendarClassName="tw-calendar"
          dayClassName={(date) =>
            cn(
              "rounded-md border-transparent text-sm leading-6 transition-colors",
              isSameDay(date, currentDate)
                ? "bg-primary text-primary-foreground"
                : "hover:bg-accent hover:text-accent-foreground",
              isSameDay(date, new Date()) && !isSameDay(date, currentDate)
                ? "ring-1 ring-primary"
                : null
            )
          }
          weekDayClassName={() =>
            "text-muted-foreground text-xs font-medium"
          }
          monthClassName={() => "text-sm font-medium"}
        />
      </div>

      <div className="flex flex-col gap-3">
        {calendars.map((calendar) => {
          const checked = activeCalendars.includes(calendar.id)
          return (
            <label
              key={calendar.id}
              htmlFor={`calendar-${calendar.id}`}
              className="border-border hover:border-primary/40 hover:bg-accent/40 text-left flex cursor-pointer items-center gap-3 rounded-lg border bg-card p-3 transition"
            >
              <Checkbox
                id={`calendar-${calendar.id}`}
                checked={checked}
                onCheckedChange={() => onToggleCalendar(calendar.id)}
              />
              <span
                className={cn("size-3.5 rounded-full", calendar.colorClass)}
                aria-hidden="true"
              />
              <div className="flex-1">
                <p className="text-sm font-medium leading-tight">
                  {calendar.label}
                </p>
                {calendar.description && (
                  <p className="text-muted-foreground text-xs">
                    {calendar.description}
                  </p>
                )}
              </div>
            </label>
          )
        })}
      </div>
    </div>
  )
}
